// Sugalarm — large trend glyph rendered alongside the hero value.

import type { Zone } from "../../lib/types";
import { zoneColor } from "../../lib/glucose";

interface Props {
  glyph: string;
  zone: Zone;
  size?: number | string;
  stale?: boolean;
  /** Cycle 297: heavier weight renders a thicker arrow (web hero). */
  weight?: number;
}

export function TrendArrow({
  glyph,
  zone,
  size = 56,
  stale = false,
  weight = 500,
}: Props) {
  return (
    <div
      style={{
        fontFamily: "var(--hero-font)",
        fontSize: size,
        lineHeight: 1,
        color: stale ? "var(--ink-3)" : zoneColor(zone),
        fontWeight: weight,
        transition: "color 200ms",
      }}
    >
      {glyph}
    </div>
  );
}
